export default __webpack_public_path__ + "fonts/mic_off.svg";